import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { JoetStoreService } from "../services/joet-store.service";

// export function routingVerificationGuard(config: any): CanActivateFn {

//   return () => {

//     const router = inject(Router);
//     const joetStoreService = inject(JoetStoreService);
//    // const role = localStorage.getItem('role');

    
   
//     // if(joetStoreService.isDriver() || joetStoreService.isCustomer()) {
//     //  if(joetStoreService.userBaseInfoForClaims()?.isAnyReviewPending) {
//     //   if (joetStoreService.isCustomer() == true) {
//     // return  router.navigate(['user/booking/submit-review', joetStoreService.userBaseInfoForClaims()?.requestIdForPendingReview ?? ""]);
//     // }
//     // if (joetStoreService.isDriver() == true) {
//     //   return router.navigate(['driver/booking/submit-review', joetStoreService.userBaseInfoForClaims()?.requestIdForPendingReview ?? ""]);
//     // }
//     //  }
//     // }
//      if (joetStoreService.getBaseDashboardRoute() === config ) {
//       return true;
//     }

//     if(joetStoreService.getBaseDashboardRoute() === 'admin') {
//       return router.createUrlTree(['/admin']);
//     }
// if(joetStoreService.getBaseDashboardRoute() === 'driver') {
//       return router.createUrlTree(['/driver']);
//     }
// if(joetStoreService.getBaseDashboardRoute() === 'user') {
//       return router.createUrlTree(['/user']);
//     }
// if(joetStoreService.getBaseDashboardRoute() === 'fleet') {
//       return router.createUrlTree(['/fleet']);
//     }



//     return router.createUrlTree(['/']);
//   };
// }


export function routingVerificationGuard(config: any): CanActivateFn {
  return async () => {
    const router = inject(Router);
    const joetStoreService = inject(JoetStoreService);

    // Ensure claims are loaded (handles hard refresh)
    if (!joetStoreService.userBaseInfoForClaims()) {
      await joetStoreService.fetchUserClaim();
    }

    const base = joetStoreService.getBaseDashboardRoute();

    if (base === config)     return true;
    if (base === 'admin')    return router.createUrlTree(['/admin']);
    if (base === 'driver')   return router.createUrlTree(['/driver']);
    if (base === 'user')     return router.createUrlTree(['/user']);
    if (base === 'fleet')    return router.createUrlTree(['/fleet']);

    return router.createUrlTree(['/']);
  };
}